import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createBlock as _createBlock, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, Transition as _Transition } from "vue"
import _imports_0 from './assets/video.mp4'
import _imports_1 from './assets/eclipseds.png'


const _hoisted_1 = { id: "non-map-container" }
const _hoisted_2 = {
  id: "title-row",
  class: "non-map-row"
}
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  id: "instructions-row",
  class: "non-map-row"
}
const _hoisted_8 = { id: "top-container-main-text" }
const _hoisted_9 = {
  key: 0,
  class: "instructions-text"
}
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "drag", -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "drag", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Enter a location", -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "highlighted bg-red" }, "Red line")
  ]),
  /*#__PURE__*/_createTextVNode(" + "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlighted bg-grey text-black" }, "Grey band"),
  /*#__PURE__*/_createTextVNode(": path of total eclipse on map ")
], -1)
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", null, "My Location", -1)
const _hoisted_27 = {
  key: 1,
  class: "d-flex justify-end",
  id: "info-text-button"
}
const _hoisted_28 = {
  key: 2,
  class: "instructions-text"
}
const _hoisted_29 = { class: "description" }
const _hoisted_30 = { class: ".d-flex" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://modis.gsfc.nasa.gov/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "MODIS", -1)
const _hoisted_32 = {
  key: 3,
  class: "instructions-text"
}
const _hoisted_33 = { class: "description" }
const _hoisted_34 = { class: ".d-flex" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "View different statistics for the data beyond just the 20-year median shown here."),
  /*#__PURE__*/_createElementVNode("p", null, " Explore whether phenomena like El Niño historically impacted cloud cover patterns.")
], -1)
const _hoisted_36 = { class: "my-2" }
const _hoisted_37 = {
  id: "button-row",
  class: "non-map-row"
}
const _hoisted_38 = { id: "top-container-buttons" }
const _hoisted_39 = { id: "map-column" }
const _hoisted_40 = ["data-before-text"]
const _hoisted_41 = {
  key: 0,
  id: "map-banner",
  class: "show-after"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "This app requires WebGL 2")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/_createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://get.webgl.org/webgl2/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "here"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_45 = { class: "video-wrapper" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("video", {
  controls: "",
  id: "info-video"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "v-btn tab-title" }, "Information", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { id: "info-text-box" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "main-info-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " On April 8, 2024, North America will be treated to an awe-inspiring total eclipse. "),
    /*#__PURE__*/_createElementVNode("p", null, " This interactive lets you explore the April total eclipse from different locations. "),
    /*#__PURE__*/_createElementVNode("p", { id: "safety-warning" }, " SAFETY FIRST: NEVER look directly at the Sun without proper eye protection. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "FAQ" }, [
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, " What causes Solar Eclipses? "),
      /*#__PURE__*/_createElementVNode("p", null, " A solar eclipse happens when the Moon passes between the Earth and the Sun and blocks the Sun from our view. Partial eclipses occur about every 6 months, somewhere on the Earth. In 2023 and 2024, the US has been lucky to be in the path of two solar eclipses. ")
    ]),
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, " Total? Annular? What is the difference?"),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" During a "),
        /*#__PURE__*/_createElementVNode("strong", null, "total eclipse"),
        /*#__PURE__*/_createTextVNode(", the Moon covers the entire face of the Sun. Because the Moon doesn't orbit the Earth in a perfect circle, sometimes it is farther away from Earth and appears smaller. When this happens, the Moon doesn't cover the entire face of the Sun. During the eclipse we can still see a bright ring of light around the Moon, sometimes called the \"Ring of Fire.\" This is called an "),
        /*#__PURE__*/_createElementVNode("strong", null, "annular Eclipse"),
        /*#__PURE__*/_createTextVNode(". ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, " What is the wispy haze around the Sun during a Total Solar Eclipse?"),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" The "),
        /*#__PURE__*/_createElementVNode("strong", null, "corona"),
        /*#__PURE__*/_createTextVNode(" is the outermost layer of the Sun's atmosphere, and it is made up of extremely hot, glowing gas. We usually can't see the corona because the Sun's surface shines so much more brightly. During a total solar eclipse, the Moon blocks light from the surface of the Sun, making it possible to see the ethereally beautiful corona. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, " Why can only some places see the eclipse?"),
      /*#__PURE__*/_createElementVNode("p", null, " An eclipse is caused by the Moon casting a shadow on the Earth. People who are directly behind the Moon will see an annular or total eclipse. As the Moon moves in its orbit around Earth, and as Earth rotates, the location of the shadow will move, sweeping out a path across the surface of the Earth. For a larger number of people who are not directly behind the moon, a smaller amount of the Sun will be blocked, causing a partial eclipse. Even further outside the shadow the Sun will not be blocked at all, and there will be no eclipse visible. "),
      /*#__PURE__*/_createElementVNode("p", null, " The animated figure shows that the Moon's shadow on Earth has two distinct regions. The darker part of the shadow is directly behind the Moon, where people will experience an annular or total eclipse. The lighter part of the shadow falls where people on Earth will see a partial solar eclipse. ")
    ]),
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, "How precise are location and timing predications in this Data Story?"),
      /*#__PURE__*/_createElementVNode("p", null, " You may notice some discrepancies in the reported eclipse percentages or with eclipse start and end times compared with other predictions. This is caused by limitations in precision for the calculations used to display the locations and sizes of the Sun and Moon on your screen. Totality timing predictions in this Data Story should be accurate to within about 15 seconds. ")
    ]),
    /*#__PURE__*/_createElementVNode("details", null, [
      /*#__PURE__*/_createElementVNode("summary", null, "Where can I learn more?"),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Check out "),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://science.nasa.gov/eclipses/future-eclipses/eclipse-2024/where-when/",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "NASA's website"),
            /*#__PURE__*/_createTextVNode(" about the April eclipse ")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" Infiniscope's Kingdom in Peril lessons on eclipses, available in "),
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://infiniscope.org/collection/3",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "English"),
            /*#__PURE__*/_createTextVNode(" and "),
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://infiniscope.org/collection/6",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Spanish")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://EclipseSoundscapes.org",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Eclipse Soundscapes"),
            /*#__PURE__*/_createTextVNode(" citizen science project ")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" Fiske Planetarium's "),
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://www.colorado.edu/fiske/projects/science-through-shadows",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Science Through Shadows"),
            /*#__PURE__*/_createTextVNode(" videos ")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("figcaption", null, "Image credit: NASA Goddard / Katy Mersmann", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, "Not to scale", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h3", { class: "v-btn tab-title" }, "User Guide", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"calc(1.1 * var(--default-font-size))"},
  class: "mb-5"
}, " This Cosmic Data Story allows you to display the April 8, 2024 Total Solar Eclipse from any location. ", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { style: {"min-height":"120px"} }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h4", { class: "user-guide-header" }, "Time Controls:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "(Bottom-left of the screen)", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", null, " By default, time is moving forward at 500x the real speed. Time slows down to 10x the real speed as the eclipse approaches totality. ", -1)
const _hoisted_59 = { class: "text-list" }
const _hoisted_60 = { class: "ml-5" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("li", { class: "ml-5" }, " Use the slider to fine-tune desired speed. ", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h4", { class: "user-guide-header" }, "Viewing Mode:", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "(Upper-right of the screen)", -1)
const _hoisted_64 = { class: "text-list" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "Selected Location"),
  /*#__PURE__*/_createTextVNode(" The currently selected location. ")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "Date/Time"),
  /*#__PURE__*/_createTextVNode(" The date and time being displayed by WorldWide Telescopse ")
], -1)
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "Eclipsed: ", -1)
const _hoisted_69 = {
  key: 1,
  class: "switch-bullets"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis" }, " Track Sun:", -1)
const _hoisted_71 = {
  key: 2,
  class: "switch-bullets mb-5"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis" }, " Don't Track Sun:", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h4", { class: "user-guide-header" }, "Display Options:", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "(Bottom-right of the screen)", -1)
const _hoisted_75 = { class: "text-list" }
const _hoisted_76 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Information Guide", -1)
const _hoisted_78 = { class: "mb-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "eclipse timing", -1)
const _hoisted_80 = { key: 1 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Center Sun:", -1)
const _hoisted_82 = { key: 2 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Sky Grid:", -1)
const _hoisted_84 = { key: 3 }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Horizon/Daytime Sky:", -1)
const _hoisted_86 = { key: 4 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Visible Moon:", -1)
const _hoisted_88 = { key: 5 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Eclipse Timing:", -1)
const _hoisted_90 = { key: 6 }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Detailed Interface:", -1)
const _hoisted_92 = {
  key: 7,
  class: "mt-2"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "Eclipsed:", -1)
const _hoisted_94 = { class: "user-guide-header" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "(Top-left of the screen)", -1)
const _hoisted_97 = { class: "text-list" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("strong", null, "My Location", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("strong", null, "share-url", -1)
const _hoisted_100 = {
  key: 0,
  class: "mt-3 mb-1"
}
const _hoisted_101 = { key: 0 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Sky Grid:", -1)
const _hoisted_103 = { key: 1 }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Horizon/Daytime Sky:", -1)
const _hoisted_105 = { key: 2 }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Visible Moon:", -1)
const _hoisted_107 = { key: 3 }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "user-guide-emphasis-white" }, "Detailed Interface:", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { id: "text-credits" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Credits:"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/_createTextVNode("Atmospheric Physicist "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.cfa.harvard.edu/people/caroline-nowlan",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Caroline Nowlan"),
    /*#__PURE__*/_createTextVNode(" provided valuable guidance on interpreting the "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://neo.gsfc.nasa.gov/view.php?datasetId=MYDAL2_E_CLD_FR&date=2023-04-07",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "MODIS Cloud Cover"),
    /*#__PURE__*/_createTextVNode(" data.")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
    /*#__PURE__*/_createTextVNode("The path of totality data are from "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://svs.gsfc.nasa.gov/5123",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "NASA's Scientific Visualization Studio"),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
    /*#__PURE__*/_createTextVNode("Eclipse Timing Predictions are by "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://eclipse.gsfc.nasa.gov/JSEX/JSEX-NA.html",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Fred Espenak and Chris O'Byrne"),
    /*#__PURE__*/_createTextVNode(" (NASA's GSFC). "),
    /*#__PURE__*/_createElementVNode("em", null, "Adapted for TypeScript by CosmicDS Team")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Image of Sun is courtesy of NASA/SDO and the AIA, EVE, and HMI science teams."),
  /*#__PURE__*/_createElementVNode("p", { class: "my-3" }, "This Cosmic Data Story is powered by WorldWide Telescope (WWT)."),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.cosmicds.cfa.harvard.edu/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "CosmicDS"),
    /*#__PURE__*/_createTextVNode(" Team:")
  ]),
  /*#__PURE__*/_createTextVNode(" John Lewis"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Jon Carifio"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Pat Udomprasert"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Jack Hayes"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Alyssa Goodman"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Mary Dussault"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Harry Houghton"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Anna Nolin"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Evaluator: Sue Sunbury"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.worldwidetelescope.org/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "WorldWide Telescope"),
    /*#__PURE__*/_createTextVNode(" Team:")
  ]),
  /*#__PURE__*/_createTextVNode(" Peter Williams"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" A. David Weigel"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Jon Carifio"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_110 = { class: "user-banner" }
const _hoisted_111 = {
  key: 0,
  class: "banner-text"
}
const _hoisted_112 = {
  key: 1,
  class: "banner-text"
}
const _hoisted_113 = { id: "main-content" }
const _hoisted_114 = {
  key: 0,
  id: "center-page-banner"
}
const _hoisted_115 = {
  id: "geocoding-row",
  class: "d-flex align-center ga-1"
}
const _hoisted_116 = {
  key: 0,
  id: "controls",
  class: "control-icon-wrapper"
}
const _hoisted_117 = { id: "controls-top-row" }
const _hoisted_118 = {
  key: 0,
  id: "control-checkboxes"
}
const _hoisted_119 = { id: "first-splash-row" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { id: "splash-screen-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "See how the "),
  /*#__PURE__*/_createElementVNode("p", { class: "highlight" }, "April 8th"),
  /*#__PURE__*/_createElementVNode("p", { class: "highlight" }, "TOTAL Solar Eclipse"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("will look from any "),
    /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "location")
  ])
], -1)
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "splash-small-text" }
const _hoisted_123 = { key: 1 }
const _hoisted_124 = { class: "splash-small-text" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { id: "splash-screen-acknowledgements" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Cosmic Data Stories Eclipse logo",
      class: "eclipse-ds-logo"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Brought to you by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cosmicds.cfa.harvard.edu/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Cosmic Data Stories"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.worldwidetelescope.org/home/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "WorldWide Telescope"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_126 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }),
  /*#__PURE__*/_createElementVNode("p", null, "Loading …")
], -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = { id: "instruction-overlay" }
const _hoisted_130 = { id: "overlay-close" }
const _hoisted_131 = { class: "inst-quad top-left" }
const _hoisted_132 = { class: "inst-arrow" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "inst-text" }, " Set location + more ", -1)
const _hoisted_134 = { class: "inst-quad top-right" }
const _hoisted_135 = { class: "inst-arrow" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "inst-text" }, " Where, when + how much ", -1)
const _hoisted_137 = { class: "inst-quad bottom-left" }
const _hoisted_138 = { class: "inst-arrow" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "inst-text" }, " New! Set time to \"Now,\" or control time yourself! ", -1)
const _hoisted_140 = { class: "inst-quad bottom-right" }
const _hoisted_141 = { class: "inst-arrow" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "inst-text" }, " Tell me what will happen and when, + new! April 8 weather ", -1)
const _hoisted_143 = {
  key: 0,
  id: "introduction-overlay",
  class: "elevation-10"
}
const _hoisted_144 = { id: "intro-window-close-button" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "intro-text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " On April 8, 2024, North America will experience a solar eclipse, where the Moon will appear to travel across the Sun, blocking out its light. "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, [
    /*#__PURE__*/_createTextVNode(" A lucky segment of Mexico, the U.S., and Canada will witness an awe-inspiring "),
    /*#__PURE__*/_createElementVNode("b", null, "total eclipse"),
    /*#__PURE__*/_createTextVNode(". Other parts of North America will still see a "),
    /*#__PURE__*/_createElementVNode("em", null, "partial"),
    /*#__PURE__*/_createTextVNode(" eclipse, where the Moon blocks out some, but not all of the Sun's light. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " See what the eclipse will look like where you are, and what the historical cloud coverage has been during the week of April 8th from 2003–2023. ")
], -1)
const _hoisted_146 = { class: "intro-text mb-3" }
const _hoisted_147 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_148 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Access these features in ", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("span", {
  class: "px-2 py-1 my-2 mr-1",
  style: {"border":"1px solid #eac402","border-radius":"1em","color":"#eac402","white-space":"nowrap"}
}, "Map & Weather", -1)
const _hoisted_150 = [
  _hoisted_148,
  _hoisted_149
]
const _hoisted_151 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_152 = /*#__PURE__*/_createElementVNode("strong", null, "Select any location", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("strong", null, "View historical cloud data", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("strong", null, "Explore historical cloud data", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("strong", null, "Learn more", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("strong", null, "User Guide", -1)
const _hoisted_157 = { id: "intro-bottom-controls" }
const _hoisted_158 = { id: "top-wwt-content" }
const _hoisted_159 = { id: "location-date-display" }
const _hoisted_160 = {
  key: 0,
  id: "top-switches"
}
const _hoisted_161 = { id: "track-sun-switch" }
const _hoisted_162 = { class: "bottom-content" }
const _hoisted_163 = {
  key: 1,
  id: "controls",
  class: "control-icon-wrapper"
}
const _hoisted_164 = { id: "controls-top-row" }
const _hoisted_165 = {
  key: 0,
  id: "control-checkboxes"
}
const _hoisted_166 = { id: "eclipse-percent-chip" }
const _hoisted_167 = { id: "video-icon" }
const _hoisted_168 = { id: "tools" }
const _hoisted_169 = { class: "tool-container" }
const _hoisted_170 = { style: {"position":"relative"} }
const _hoisted_171 = { id: "speed-control" }
const _hoisted_172 = {
  key: 1,
  id: "inline-speed-control"
}
const _hoisted_173 = { id: "speed-text" }
const _hoisted_174 = { key: 0 }
const _hoisted_175 = { key: 1 }
const _hoisted_176 = { key: 2 }
const _hoisted_177 = { key: 3 }
const _hoisted_178 = { id: "slider" }
const _hoisted_179 = { id: "change-optout" }
const _hoisted_180 = {
  key: 2,
  id: "body-logos"
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("strong", null, "anonymized", -1)
const _hoisted_182 = { id: "user-experience-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_define_term = _resolveComponent("define-term")!
  const _component_cloud_cover = _resolveComponent("cloud-cover")!
  const _component_location_search = _resolveComponent("location-search")!
  const _component_location_selector = _resolveComponent("location-selector")!
  const _component_color_bar = _resolveComponent("color-bar")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_gif_play_pause = _resolveComponent("gif-play-pause")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_advanced_weather_view = _resolveComponent("advanced-weather-view")!
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_geolocation_button = _resolveComponent("geolocation-button")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_hover_tooltip = _resolveComponent("hover-tooltip")!
  const _component_open_meteo_forecast = _resolveComponent("open-meteo-forecast")!
  const _component_eclipse_timer = _resolveComponent("eclipse-timer")!
  const _component_playback_control = _resolveComponent("playback-control")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: "closed-top-container",
        class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : 'open'])
      }, [
        _createVNode(_component_icon_button, {
          modelValue: _ctx.showGuidedContent,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showGuidedContent) = $event)),
          id: "show-guided-content",
          ref: "showGuidedContent",
          "fa-icon": _ctx.showGuidedContent ? 'times' : 'chevron-down',
          "fa-size": _ctx.showGuidedContent ? 'lg' : 'lg',
          color: _ctx.accentColor,
          "focus-color": _ctx.showGuidedContent ? _ctx.skyColor : _ctx.accentColor,
          "tooltip-text": _ctx.showGuidedContent ? 'Hide' : 'Click to learn more',
          "tooltip-location": 'bottom',
          "show-tooltip": !_ctx.mobile,
          "box-shadow": false,
          onActivate: _cache[1] || (_cache[1] = () => {
        // console.log('showGuidedContent = ', showGuidedContent);
        // showGuidedContent = !showGuidedContent;
        _ctx.onResize();
      })
        }, _createSlots({ _: 2 }, [
          (!_ctx.showGuidedContent)
            ? {
                name: "button",
                fn: _withCtx(() => [
                  _createTextVNode(" Map & Weather "),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "chevron-down",
                    class: "bullet-icon"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue", "fa-icon", "fa-size", "color", "focus-color", "tooltip-text", "show-tooltip"])
      ], 2),
      _withDirectives(_createVNode(_component_v_container, { id: "guided-content-container" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.learnerPath=='Location')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Choose Any Location "))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Clouds')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "View Historical Cloud Data "))
                  : _createCommentVNode("", true),
                (!_ctx.showNewMobileUI && _ctx.learnerPath=='CloudDetail')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Explore Detailed Cloud Data "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.learnerPath=='Location')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        (_ctx.infoPage==1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_ctx.queryData.latitudeDeg == undefined || _ctx.queryData.longitudeDeg == undefined)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                    _createTextVNode(" \"Watch\" the eclipse from the location marked by the red dot on the map, or "),
                                    _hoisted_13,
                                    _createTextVNode(" the yellow dot along the bottom slider to change time. ")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.queryData.latitudeDeg !== undefined && _ctx.queryData.longitudeDeg !== undefined)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                    _createTextVNode(" \"Watch\" the eclipse from the location shared in your link, or "),
                                    _hoisted_15,
                                    _createTextVNode(" the yellow dot along the bottom slider to change time. ")
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                                _createTextVNode(" the map to select any "),
                                (_ctx.queryData.latitudeDeg !== undefined && _ctx.queryData.longitudeDeg !== undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "other"))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" location and view the eclipse from there, or ")
                              ]),
                              (_ctx.narrow)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "magnifying-glass",
                                      class: "bullet-icon",
                                      size: "lg"
                                    }),
                                    _createTextVNode(" Search for a location ")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.narrow)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "location-crosshairs",
                                      class: "bullet-icon",
                                      size: "lg"
                                    }),
                                    _createTextVNode(" Use my location (if enabled) ")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.narrow)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-sun-clock",
                                      size: "small",
                                      class: "bullet-icon"
                                    }),
                                    _createTextVNode(" See detailed eclipse times ")
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                    _hoisted_21,
                                    _createTextVNode(" in the search box below. ")
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.infoPage==2 && !_ctx.narrow)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("p", _hoisted_24, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-sun-clock",
                                  size: "large",
                                  class: "bullet-icon"
                                }),
                                _createTextVNode(" to see detailed eclipse times ")
                              ]),
                              (_ctx.getMyLocation)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "location-crosshairs",
                                      class: "bullet-icon"
                                    }),
                                    _createTextVNode(" to view eclipse from "),
                                    _hoisted_26,
                                    _createTextVNode(" (Location services must be enabled on device) ")
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                                _createTextVNode(),
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "share-nodes",
                                  class: "bullet-icon"
                                }),
                                _createTextVNode(" to copy url to share a location ")
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Location' && !_ctx.narrow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_ctx.infoPage==1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "mr-2 mb-2",
                            density: "compact",
                            "hide-details": "",
                            color: _ctx.accentColor,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.infoPage++)),
                            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.infoPage++), ["enter"])),
                            elevation: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" More ")
                            ]),
                            _: 1
                          }, 8, ["color"]))
                        : _createCommentVNode("", true),
                      (_ctx.infoPage==2)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "mr-2 mb-2",
                            density: "compact",
                            color: _ctx.accentColor,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.infoPage--)),
                            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.infoPage--), ["enter"])),
                            elevation: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Back ")
                            ]),
                            _: 1
                          }, 8, ["color"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Clouds')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", null, [
                            _createTextVNode(" This map shows historical cloud cover data for the week of April 8 for the years 2003–2023 from "),
                            _hoisted_31,
                            _createTextVNode(" on NASA's Aqua satellite. " + _toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " the map to display the ", 1),
                            _createVNode(_component_define_term, {
                              term: "median",
                              definition: "For <strong>half</strong> of the years from 2003–2023 on April 8, the cloud cover amount was <strong>less</strong> than the median value. For the other <strong>half</strong> of the years, the cloud cover was <strong>more</strong> than the median value."
                            }),
                            _createTextVNode(" cloud coverage for a particular location (within about 100 km). Learn more in the "),
                            _createVNode(_component_v_btn, {
                              style: {"padding-inline":"2px"},
                              class: _normalizeClass([_ctx.smallSize ? 'text-caption' : '']),
                              color: _ctx.accentColor,
                              density: "compact",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAdvancedWeather = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Cloud Data Explorer")
                              ]),
                              _: 1
                            }, 8, ["class", "color"]),
                            _createTextVNode(". ")
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_cloud_cover, {
                              "cloud-cover": _ctx.selectedLocationCloudCover,
                              onCloudIcon: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cloudIcon = $event))
                            }, null, 8, ["cloud-cover"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='CloudDetail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_36, [
                              _createTextVNode("Open the "),
                              _createVNode(_component_v_btn, {
                                class: _normalizeClass([_ctx.smallSize ? 'text-caption' : '']),
                                color: _ctx.accentColor,
                                density: "compact",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAdvancedWeather = true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cloud Data Explorer")
                                ]),
                                _: 1
                              }, 8, ["class", "color"])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_icon_button, {
                  "model-value": _ctx.learnerPath == 'Location',
                  "fa-icon": "location-dot",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": 'Choose any viewing location',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false,
                  onActivate: _cache[9] || (_cache[9] = () => { _ctx.learnerPath = 'Location'})
                }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  "model-value": _ctx.learnerPath == 'Clouds',
                  "fa-icon": "cloud-sun",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": 'View historical cloud coverage',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false,
                  onActivate: _cache[10] || (_cache[10] = () => { _ctx.learnerPath = 'Clouds'})
                }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                (!_ctx.showNewMobileUI)
                  ? (_openBlock(), _createBlock(_component_icon_button, {
                      key: 0,
                      "model-value": _ctx.learnerPath == 'CloudDetail',
                      "fa-icon": "chart-column",
                      "fa-size": "xl",
                      color: _ctx.accentColor,
                      "focus-color": _ctx.accentColor,
                      "tooltip-text": 'Explore detailed historical cloud coverage',
                      "tooltip-location": 'bottom',
                      "show-tooltip": !_ctx.mobile,
                      "box-shadow": false,
                      onActivate: _cache[11] || (_cache[11] = () => { _ctx.learnerPath = 'CloudDetail'})
                    }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showInfoSheet,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
                  "fa-icon": "book-open",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": _ctx.showInfoSheet ? null : 'More on Eclipses',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false
                }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showWWTGuideSheet,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showWWTGuideSheet) = $event)),
                  "fa-icon": "circle-info",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": _ctx.showWWTGuideSheet ? null : 'User Guide',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false
                }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_v_hover, null, {
              default: _withCtx(({isHovering, props}) => [
                (false &&!isHovering && !_ctx.smAndUp)
                  ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                      color: "blue",
                      width: '100%'
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode("Tap here to reveal map")
                      ]),
                      _: 2
                    }, 1040))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_slide_y_transition, { disabled: _ctx.smAndUp }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(['']),
                      id: "map-container",
                      "data-before-text": _ctx.eclipsePredictionText
                    }, [
                      (_ctx.learnerPath === 'Location' && _ctx.showEclipsePredictionTextBanner && !_ctx.mobile && !_ctx.showNewMobileUI)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_ctx.showEclipsePredictionText)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                  _createTextVNode(_toDisplayString(_ctx.eclipsePredictionText) + " ", 1),
                                  (_ctx.narrow)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        style: {"padding":"2px","border-radius":"3px","background-color":"#ddd"},
                                        class: "elevation-2",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.showEclipsePredictionSheet = true; _ctx.showEclipsePredictionText = true})
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-sun-clock")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                  _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                  _createVNode(_component_v_icon, {
                                    style: {"padding":"2px","border-radius":"3px","background-color":"#ddd"},
                                    class: "elevation-2",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.showEclipsePredictionSheet = true; _ctx.showEclipsePredictionText = true})
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-sun-clock")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" to see eclipse predictions ")
                                ])),
                            _createElementVNode("span", {
                              class: "banner-close",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showEclipsePredictionTextBanner = false))
                            }, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-close")
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.narrow)
                        ? (_openBlock(), _createBlock(_component_location_search, {
                            key: 1,
                            modelValue: _ctx.searchOpen,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchOpen) = $event)),
                            class: _normalizeClass(['location-search-overmap', _ctx.learnerPath === 'Clouds' ? 'overmap-budge' : '', _ctx.showNewMobileUI ? '' : 'overmap-low']),
                            small: "",
                            buttonSize: "xl",
                            "search-provider": _ctx.geocodingInfoForSearch,
                            accentColor: _ctx.accentColor,
                            onSetLocation: _ctx.setLocationFromSearchFeature,
                            onError: _cache[18] || (_cache[18] = ($event: any) => (_ctx.searchErrorMessage = $event))
                          }, null, 8, ["modelValue", "class", "search-provider", "accentColor", "onSetLocation"]))
                        : _createCommentVNode("", true),
                      (_ctx.getMyLocation && _ctx.narrow)
                        ? (_openBlock(), _createBlock(_component_icon_button, {
                            key: 2,
                            id: 'my-location-overmap' + (_ctx.learnerPath === 'Clouds' ? '-budge' : ''),
                            "fa-icon": "location-crosshairs",
                            "fa-size": "2xl",
                            color: _ctx.myLocationColor,
                            "focus-color": _ctx.myLocationColor,
                            "box-shadow": false,
                            "tooltip-text": _ctx.myLocationToolTip,
                            "show-tooltip": !_ctx.mobile,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = (value) => {
              if(value) {
                (_ctx.$refs.geolocation as any).getLocation();
                _ctx.showMyLocationDialog = true;
                _ctx.learnerPath = 'Location';
              }
              else {
                console.log('geolocation button pressed = false');
              }

            })
                          }, null, 8, ["id", "color", "focus-color", "tooltip-text", "show-tooltip"]))
                        : _createCommentVNode("", true),
                      (_ctx.narrow)
                        ? (_openBlock(), _createBlock(_component_icon_button, {
                            key: 3,
                            id: "eclipse-details-overmap",
                            "md-icon": "sun-clock",
                            "md-size": "24",
                            color: _ctx.accentColor,
                            "focus-color": _ctx.accentColor,
                            "tooltip-text": "View eclipse timing details",
                            "tooltip-location": "start",
                            onActivate: _cache[20] || (_cache[20] = () => {
                _ctx.showEclipsePredictionSheet = true;
                if (!_ctx.showEclipsePredictionText) {
                  _ctx.showEclipsePredictionTextBanner = !_ctx.showNewMobileUI;
                }
                _ctx.showEclipsePredictionText = true;
              })
                          }, null, 8, ["color", "focus-color"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_location_selector, {
                        "model-value": _ctx.locationDeg,
                        "onUpdate:modelValue": _ctx.updateLocationFromMap,
                        "place-circle-options": _ctx.placeCircleOptions,
                        "detect-location": false,
                        "map-options": (['Clouds', 'CloudDetail'].includes(_ctx.learnerPath)) ? _ctx.userSelectedMapOptions : _ctx.initialMapOptions,
                        "selected-circle-options": _ctx.selectedCircleOptions,
                        "show-cloud-cover": ['Clouds', 'CloudDetail'].includes(_ctx.learnerPath) && _ctx.cloudCoverData !== null,
                        class: "leaflet-map",
                        "geo-json-files": _ctx.geojson,
                        "selected-cloud-cover": _ctx.selectedCloudCoverData,
                        "cloud-cover-opacity-function": _ctx.sigmoid
                      }, null, 8, ["model-value", "onUpdate:modelValue", "place-circle-options", "map-options", "selected-circle-options", "show-cloud-cover", "geo-json-files", "selected-cloud-cover", "cloud-cover-opacity-function"]),
                      (_ctx.learnerPath === 'Clouds')
                        ? (_openBlock(), _createBlock(_component_color_bar, {
                            key: 4,
                            label: "Historical Cloud Cover %",
                            cmap: _ctx.cloudColorMap
                          }, null, 8, ["cmap"]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_40)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.showGuidedContent]
      ]),
      _createVNode(_component_v_dialog, {
        class: "error-dialog",
        style: _normalizeStyle(_ctx.cssVars),
        modelValue: _ctx.showWebGL2Warning,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style", "modelValue"]),
      _createVNode(_component_v_dialog, {
        id: "video-container",
        modelValue: _ctx.showVideoSheet,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
        transition: "slide-y-transition",
        "close-on-back": "",
        fullscreen: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_font_awesome_icon, {
              id: "video-close-icon",
              class: "close-icon",
              icon: "times",
              size: "lg",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showVideoSheet = false)),
              onKeyup: _cache[23] || (_cache[23] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
              tabindex: "0"
            }),
            _hoisted_46
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        transition: "slide-y-transition",
        modelValue: _ctx.showInfoSheet,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
        class: "bottom-sheet",
        id: "text-bottom-sheet",
        style: _normalizeStyle(_ctx.cssVars)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "bottom-sheet-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { tabindex: "0" }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }),
              _createVNode(_component_font_awesome_icon, {
                id: "close-text-icon",
                class: "control-icon",
                icon: `square-xmark`,
                size: "xl",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showInfoSheet = false)),
                onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (_ctx.showInfoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { id: "learn-more-content" }, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _createElementVNode("figure", null, [
                            _createVNode(_component_gif_play_pause, {
                              startPaused: "",
                              gif: require("./assets/eclipse.gif"),
                              still: require("./assets/eclipse_static.gif"),
                              alt: "Animated schematic of a solar eclipse showing how the Moon moves between the Sun and Earth."
                            }, null, 8, ["gif", "still"]),
                            _hoisted_49,
                            _hoisted_50
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        transition: "slide-y-transition",
        modelValue: _ctx.showWWTGuideSheet,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.showWWTGuideSheet) = $event)),
        class: "bottom-sheet",
        id: "wwt-guide-sheet",
        style: _normalizeStyle(_ctx.cssVars)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "bottom-sheet-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { tabindex: "0" }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              }),
              _createVNode(_component_font_awesome_icon, {
                id: "close-text-icon",
                class: "control-icon",
                icon: `square-xmark`,
                size: "xl",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showWWTGuideSheet = false)),
                onKeyup: _cache[29] || (_cache[29] = _withKeys(($event: any) => (_ctx.showWWTGuideSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { id: "user-guide" }, {
                        default: _withCtx(() => [
                          _hoisted_52,
                          _createVNode(_component_v_row, { align: "center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_chip, {
                                    label: "",
                                    outlined: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Pan ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "8",
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "W-A-S-D"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                  _hoisted_53
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { align: "center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_chip, {
                                    label: "",
                                    outlined: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Zoom ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "8",
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "I-O"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                  _hoisted_54
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_55, [
                                    _hoisted_56,
                                    _hoisted_57,
                                    _hoisted_58,
                                    _createElementVNode("ul", _hoisted_59, [
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "angles-left",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to reverse time, or to increase reverse speed by 10x if time was already reversed. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "play",
                                          size: "lg"
                                        }),
                                        _createTextVNode("/ "),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "pause",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to play or pause time. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "angles-right",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to increase speed by 10x, or to move time forward if time was reversed. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "rotate",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to reset starting time and speed. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "gauge-high",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to open more speed controls. ")
                                      ]),
                                      _createElementVNode("ul", null, [
                                        _createElementVNode("li", _hoisted_60, [
                                          _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                          _createVNode(_component_v_icon, {
                                            class: "bullet-icon",
                                            icon: "mdi-step-forward-2",
                                            size: "medium"
                                          }),
                                          _createTextVNode(" or "),
                                          _createVNode(_component_v_icon, {
                                            class: "bullet-icon",
                                            icon: "mdi-step-backward-2",
                                            size: "medium"
                                          }),
                                          _createTextVNode(" to move time forward and backward. ")
                                        ]),
                                        _hoisted_61
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(" Drag "),
                                        _createVNode(_component_v_icon, {
                                          class: "bullet-icon",
                                          icon: "mdi-circle",
                                          size: "medium"
                                        }),
                                        _createTextVNode(" along the main slider to move to any time. ")
                                      ])
                                    ]),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _hoisted_62,
                                    _hoisted_63,
                                    _createElementVNode("ul", _hoisted_64, [
                                      _hoisted_65,
                                      _hoisted_66,
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                            _hoisted_68,
                                            _createTextVNode(" The fraction of the Sun that is eclipsed in the currenty view (for the selected time and location). ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                            _createVNode(_component_v_switch, {
                                              class: "display-only-switch",
                                              modelValue: _ctx.displaySwitchOn,
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.displaySwitchOn) = $event)),
                                              density: "compact",
                                              "hide-details": "",
                                              disabled: "",
                                              ripple: false,
                                              color: _ctx.accentColor,
                                              "true-icon": "mdi-white-balance-sunny"
                                            }, null, 8, ["modelValue", "color"]),
                                            _hoisted_70,
                                            _createTextVNode(" Camera follows the Sun. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                                            _createVNode(_component_v_switch, {
                                              class: "display-only-switch",
                                              modelValue: _ctx.displaySwitchOff,
                                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.displaySwitchOff) = $event)),
                                              density: "compact",
                                              "hide-details": "",
                                              disabled: "",
                                              ripple: false,
                                              color: _ctx.accentColor,
                                              "false-icon": "mdi-image"
                                            }, null, 8, ["modelValue", "color"]),
                                            _hoisted_72,
                                            _createTextVNode(" Camera stays fixed and shows motion of Sun (and Moon) against the sky. ")
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _hoisted_73,
                                    _hoisted_74,
                                    _createElementVNode("ul", _hoisted_75, [
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_76, [
                                            _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                            _createVNode(_component_font_awesome_icon, {
                                              class: "bullet-icon",
                                              icon: "book-open",
                                              size: "lg"
                                            }),
                                            _createTextVNode(" to open "),
                                            _hoisted_77,
                                            _createTextVNode(" on why eclipses happen and more. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("li", _hoisted_78, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_v_icon, {
                                          class: "bullet-icon",
                                          icon: "mdi-sun-clock",
                                          size: "large"
                                        }),
                                        _createTextVNode(" to display detailed "),
                                        _hoisted_79,
                                        _createTextVNode(" predictions for your selected location. ")
                                      ]),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_80, [
                                            _hoisted_81,
                                            _createTextVNode(" Recenter view on Sun. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_82, [
                                            _hoisted_83,
                                            _createTextVNode(" Display altitude/azimuth grid with cardinal directions. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                            _hoisted_85,
                                            _createTextVNode(" Display a virtual \"ground\" that delineates where the Sun rises and sets. Show a blue sky when the Sun is above the horizon. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_86, [
                                            _hoisted_87,
                                            _createTextVNode(" Solar Eclipses occur during a New Moon, when the Moon is not normally visible in the sky. This option makes it easier to see the Moon against the sky. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_88, [
                                            _hoisted_89,
                                            _createTextVNode(" Display eclipse start time for your selected location. If applicable, display duration of totality. (This appears at the top of the map if it is open, and at the top of the screen if the map is closed.) ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.narrow && !_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_90, [
                                            _hoisted_91,
                                            _createTextVNode(" Switch to original mobile interface. (Uncheck box to use new streamlined interface) ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                                            _hoisted_93,
                                            _createTextVNode(" The fraction of the Sun that is eclipsed in the currenty view (for the selected time and location). ")
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _createElementVNode("h4", _hoisted_94, [
                                      _createTextVNode("Location "),
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_95, "and other"))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" Options:")
                                    ]),
                                    _hoisted_96,
                                    _createElementVNode("ul", _hoisted_97, [
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "magnifying-glass",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to search for a specific location name. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "location-crosshairs",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to view from "),
                                        _hoisted_98,
                                        _createTextVNode(". (If icon is grayed out, consult your device's user guide to enable location services. This feature works most reliably on Chrome and might not be available on every browser+operating system combination.) ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "share-nodes",
                                          size: "lg"
                                        }),
                                        _createTextVNode(" to copy "),
                                        _hoisted_99,
                                        _createTextVNode(" for a specific location. ")
                                      ])
                                    ]),
                                    (_ctx.showNewMobileUI)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_100, [
                                          _createTextVNode(" Tap "),
                                          _createVNode(_component_font_awesome_icon, {
                                            class: "bullet-icon",
                                            icon: "gear",
                                            size: "lg"
                                          }),
                                          _createTextVNode(" to access more options: ")
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("ul", null, [
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_101, [
                                            _hoisted_102,
                                            _createTextVNode(" Display altitude/azimuth grid with cardinal directions. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                                            _hoisted_104,
                                            _createTextVNode(" Display a virtual \"ground\" that delineates where the Sun rises and sets. Show a blue sky when the Sun is above the horizon. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                                            _hoisted_106,
                                            _createTextVNode(" Solar Eclipses occur during a New Moon, when the Moon is not normally visible in the sky. This option makes it easier to see the Moon against the sky. ")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showNewMobileUI)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_107, [
                                            _hoisted_108,
                                            _createTextVNode(" Switch to original mobile interface. (Uncheck box to use new streamlined interface) ")
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createVNode(_component_v_divider, {
                                    thickness: "2px",
                                    class: "solid-divider"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_109,
                          _createVNode(_component_funding_acknowledgment)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createVNode(_component_advanced_weather_view, {
        modelValue: _ctx.showAdvancedWeather,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.showAdvancedWeather) = $event)),
        onExplainerOpen: _cache[34] || (_cache[34] = (open) => { _ctx.weatherInfoOpen = open }),
        "default-location": _ctx.locationDeg,
        "show-on-map": _ctx.showAWVMapByDefault,
        "show-charts": _ctx.showAWVChartsByDefault,
        fullscreen: _ctx.showAWVFullScreen,
        onLocation: _cache[35] || (_cache[35] = (loc) => {
      _ctx.advancedWeatherSelectedCount += 1;
      _ctx.cloudCoverSelectedLocations.push([loc.latitudeDeg, loc.longitudeDeg]);
    }),
        onClose: _cache[36] || (_cache[36] = (loc) => {
      _ctx.updateLocationFromMap(loc, false);
    })
      }, null, 8, ["modelValue", "default-location", "show-on-map", "show-charts", "fullscreen"]),
      _withDirectives(_createElementVNode("div", _hoisted_110, [
        (_ctx.showEclipsePredictionText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_ctx.eclipsePredictionText), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_112, [
              _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-sun-clock")
                ]),
                _: 1
              }),
              _createTextVNode(" to see eclipse predictions ")
            ])),
        _createElementVNode("span", {
          class: "banner-close",
          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.showEclipsePredictionTextBanner = false))
        }, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, !_ctx.showGuidedContent && _ctx.showEclipsePredictionTextBanner && !_ctx.showNewMobileUI]
      ]),
      _createElementVNode("div", _hoisted_113, [
        ((_ctx.sunPosition.altRad < -.25 * Math.PI/180))
          ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
              _createElementVNode("p", null, " The Sun has " + _toDisplayString(_ctx.sunPosition.azRad < Math.PI ? 'not risen yet' : 'set'), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          onPointerdown: _ctx.onPointerDown,
          onPointerup: _ctx.onPointerUp
        }, null, 8, ["wwt-namespace", "onPointerdown", "onPointerup"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            id: "left-buttons-wrapper",
            class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
          }, [
            _createElementVNode("div", _hoisted_115, [
              _createVNode(_component_location_search, {
                class: "location-search-overwwt",
                modelValue: _ctx.searchOpen,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.searchOpen) = $event)),
                "search-provider": _ctx.geocodingInfoForSearch,
                accentColor: _ctx.accentColor,
                onSetLocation: _ctx.setLocationFromSearchFeature,
                onError: _cache[39] || (_cache[39] = ($event: any) => (_ctx.searchErrorMessage = $event)),
                small: "",
                buttonSize: "lg"
              }, null, 8, ["modelValue", "search-provider", "accentColor", "onSetLocation"])
            ]),
            _createElementVNode("div", null, [
              (_ctx.getMyLocation)
                ? (_openBlock(), _createBlock(_component_icon_button, {
                    key: 0,
                    class: "geolocation-button",
                    id: "my-location",
                    "fa-icon": "location-crosshairs",
                    color: _ctx.myLocationColor,
                    "focus-color": _ctx.myLocationColor,
                    "box-shadow": false,
                    "tooltip-text": _ctx.myLocationToolTip,
                    "show-tooltip": !_ctx.mobile,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = (value) => {
              if(value) {
                (_ctx.$refs.geolocation as any).getLocation();
                _ctx.showMyLocationDialog = true;
                _ctx.learnerPath = 'Location';
              }
              else {
                console.log('geolocation button pressed = false');
              }

            }),
                    faSize: "lg"
                  }, null, 8, ["color", "focus-color", "tooltip-text", "show-tooltip"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                id: "location-progress",
                class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
              }, [
                _createVNode(_component_geolocation_button, {
                  color: _ctx.accentColor,
                  "show-text-progress": true,
                  "hide-button": "",
                  "show-progress-circle": "",
                  ref: "geolocation",
                  onGeolocation: _cache[41] || (_cache[41] = (loc) => { 
                _ctx.myLocation = {
                  latitudeDeg: loc.latitude, 
                  longitudeDeg: loc.longitude
                };
                _ctx.showMyLocationDialog = false;
                
                if (_ctx.myLocation.latitudeDeg !== _ctx.locationDeg.latitudeDeg || _ctx.myLocation.longitudeDeg !== _ctx.locationDeg.longitudeDeg) {
                  _ctx.locationDeg = _ctx.myLocation;
                  _ctx.$nextTick(() => {
                    _ctx.updateSelectedLocationText();
                  });
                }
              }),
                  onError: _cache[42] || (_cache[42] = (error) => { 
                _ctx.$notify({
                  group: 'geolocation-error',
                  title: 'Error',
                  text: error.message,
                  type: 'error',
                }); 
                if (error.code === 1) {
                  _ctx.geolocationPermission = 'denied';
                }
                console.log(error);
              }),
                  onPermission: _cache[43] || (_cache[43] = (p) => {
                _ctx.geolocationPermission = p;
                // we're always gonna show the button,
                // just leaving this if we wanna change
                if (p == 'granted') {
                  _ctx.getMyLocation = true;
                } else if (p == 'prompt') {
                  _ctx.getMyLocation = true;
                } else {
                  _ctx.getMyLocation = true;
                }
              })
                }, null, 8, ["color"])
              ], 2)
            ]),
            _createVNode(_component_icon_button, {
              id: "share",
              "fa-icon": "share-nodes",
              color: _ctx.accentColor,
              "focus-color": _ctx.accentColor,
              "box-shadow": false,
              "tooltip-text": "Share view of this location",
              "show-tooltip": !_ctx.mobile,
              onActivate: _ctx.copyShareURL,
              faSize: "lg"
            }, null, 8, ["color", "focus-color", "show-tooltip", "onActivate"]),
            (_ctx.showNewMobileUI)
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, [
                    _createVNode(_component_font_awesome_icon, {
                      size: "lg",
                      color: _ctx.accentColor,
                      icon: _ctx.showControls ? `chevron-down` : `gear`,
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.showControls = !_ctx.showControls)),
                      onKeyup: _cache[45] || (_cache[45] = _withKeys(($event: any) => (_ctx.showControls = !_ctx.showControls), ["enter"])),
                      tabindex: "0"
                    }, null, 8, ["color", "icon"])
                  ]),
                  (_ctx.showControls)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        (!_ctx.showNewMobileUI)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              color: _ctx.accentColor,
                              modelValue: _ctx.sunCenteredTracking,
                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.sunCenteredTracking) = $event)),
                              onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.centerSun())),
                              label: "Center Sun",
                              disabled: _ctx.sunCenteredTracking,
                              "hide-details": ""
                            }, null, 8, ["color", "modelValue", "disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_checkbox, {
                          color: _ctx.accentColor,
                          modelValue: _ctx.showAltAzGrid,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.showAltAzGrid) = $event)),
                          onKeyup: _cache[49] || (_cache[49] = _withKeys(($event: any) => (_ctx.showAltAzGrid = !_ctx.showAltAzGrid), ["enter"])),
                          label: "Sky Grid",
                          "hide-details": ""
                        }, null, 8, ["color", "modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          color: _ctx.accentColor,
                          modelValue: _ctx.showHorizon,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showHorizon) = $event)),
                          onKeyup: _cache[51] || (_cache[51] = _withKeys(($event: any) => (_ctx.showHorizon = !_ctx.showHorizon), ["enter"])),
                          label: "Horizon/Daytime Sky",
                          "hide-details": ""
                        }, null, 8, ["color", "modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          color: _ctx.accentColor,
                          modelValue: _ctx.useRegularMoon,
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.useRegularMoon) = $event)),
                          onKeyup: _cache[53] || (_cache[53] = _withKeys(($event: any) => (_ctx.useRegularMoon = !_ctx.useRegularMoon), ["enter"])),
                          label: "Visible Moon",
                          "hide-details": ""
                        }, null, 8, ["color", "modelValue"]),
                        _withDirectives(_createVNode(_component_v_checkbox, {
                          color: _ctx.accentColor,
                          modelValue: _ctx.showEclipsePredictionTextBanner,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.showEclipsePredictionTextBanner) = $event)),
                          onKeyup: _cache[55] || (_cache[55] = _withKeys(($event: any) => (_ctx.showEclipsePredictionTextBanner = !_ctx.showEclipsePredictionTextBanner), ["enter"])),
                          label: "Eclipse Timing",
                          "hide-details": ""
                        }, null, 8, ["color", "modelValue"]), [
                          [_vShow, !_ctx.showNewMobileUI]
                        ]),
                        _withDirectives(_createVNode(_component_v_checkbox, {
                          color: _ctx.accentColor,
                          modelValue: _ctx.showOldMobileUI,
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.showOldMobileUI) = $event)),
                          onKeyup: _cache[57] || (_cache[57] = _withKeys(($event: any) => {_ctx.showOldMobileUI = !_ctx.showOldMobileUI;}, ["enter"])),
                          label: "Detailed Interface",
                          "hide-details": ""
                        }, null, 8, ["color", "modelValue"]), [
                          [_vShow, _ctx.narrow]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay",
          class: _normalizeClass([_ctx.showNewMobileUI ? 'new-mobile-ui' : ''])
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", {
                  id: "close-splash-button",
                  onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.closeSplashScreen && _ctx.closeSplashScreen(...args)))
                }, "×"),
                _hoisted_120
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Get Started ")
                  ]),
                  _: 1
                }, 8, ["onClick", "color", "density"])
              ]),
              (_ctx.narrow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                    _createElementVNode("p", _hoisted_122, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => (_ctx.showNewMobileUI = !_ctx.showNewMobileUI), ["prevent"]))
                      }, "Switch"),
                      _createTextVNode(" to " + _toDisplayString(_ctx.showNewMobileUI ? "detailed" : "new streamlined") + " interface ", 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    _createElementVNode("p", _hoisted_124, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-creation",
                        size: "small",
                        class: "bullet-icon"
                      }),
                      _createTextVNode(" New! NOW button, active starting at 6:40am EDT ")
                    ])
                  ])),
              _hoisted_125
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style", "class"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_126, _hoisted_128, 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        (_ctx.showNewMobileUI)
          ? (_openBlock(), _createBlock(_component_v_overlay, {
              key: 1,
              modelValue: _ctx.inIntro,
              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.inIntro) = $event)),
              opacity: "1",
              scrim: false,
              "close-on-content-click": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _createVNode(_component_v_icon, {
                      class: "overlay-close-icon",
                      icon: "mdi-close-box",
                      color: "gray",
                      onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.inIntro = !_ctx.inIntro)),
                      onKeyup: _cache[61] || (_cache[61] = _withKeys(($event: any) => (_ctx.inIntro = !_ctx.inIntro), ["enter"])),
                      tabindex: "0"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-arrow-up-bold")
                        ]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _hoisted_133
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-arrow-up-bold")
                        ]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _hoisted_136
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-arrow-up-bold")
                        ]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _hoisted_139
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-arrow-up-bold")
                        ]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _hoisted_142
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (!_ctx.showNewMobileUI)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 2,
              modelValue: _ctx.inIntro,
              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.inIntro) = $event)),
              style: _normalizeStyle(_ctx.cssVars),
              scrim: false,
              persistent: false
            }, {
              default: _withCtx(() => [
                (_ctx.inIntro)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.introSlide,
                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.introSlide) = $event))
                      }, {
                        additional: _withCtx(() => [
                          _createElementVNode("div", _hoisted_144, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "xl",
                              class: "ma-1",
                              color: "#b3d5e6",
                              icon: "square-xmark",
                              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.inIntro = !_ctx.inIntro)),
                              onKeyup: _cache[64] || (_cache[64] = _withKeys(($event: any) => (_ctx.inIntro = !_ctx.inIntro), ["enter"])),
                              tabindex: "0",
                              "tooltip-location": "start"
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_145
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 2 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_146, [
                                (_ctx.xSmallSize)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, _hoisted_150))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_151, " In this interactive page you can: ")),
                                _createElementVNode("ul", null, [
                                  _createVNode(_component_v_list_item, { density: "compact" }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "location-dot",
                                        size: "xl",
                                        class: "bullet-icon"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_152,
                                      _createTextVNode(" around the world. See and share how the eclipse would look from there. ")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, { density: "compact" }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "cloud-sun",
                                        size: "xl",
                                        class: "bullet-icon"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_153,
                                      _createTextVNode(" for the week of April 8th from 2003–2023. ")
                                    ]),
                                    _: 1
                                  }),
                                  (!_ctx.showNewMobileUI)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 0,
                                        density: "compact"
                                      }, {
                                        prepend: _withCtx(() => [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: "chart-column",
                                            size: "xl",
                                            class: "bullet-icon"
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _hoisted_154,
                                          _createTextVNode(" as individual years or filter by El Niño/La Niña climate patterns. ")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, { density: "compact" }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "book-open",
                                        size: "xl",
                                        class: "bullet-icon"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_155,
                                      _createTextVNode(" about solar eclipses. ")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, { density: "compact" }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "circle-info",
                                        size: "xl",
                                        class: "bullet-icon"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" Access "),
                                      _hoisted_156,
                                      _createTextVNode(" on how to navigate this app. ")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("div", null, [
                          ((_ctx.introSlide > 1) && (!_ctx.showNewMobileUI))
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                id: "intro-next-button",
                                color: _ctx.accentColor,
                                onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.introSlide--)),
                                onKeyup: _cache[67] || (_cache[67] = _withKeys(($event: any) => (_ctx.introSlide--), ["enter"])),
                                elevation: "0"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Back ")
                                ]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_btn, {
                          id: "intro-next-button",
                          color: _ctx.accentColor,
                          onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.introSlide++)),
                          onKeyup: _cache[69] || (_cache[69] = _withKeys(($event: any) => (_ctx.introSlide++), ["enter"])),
                          elevation: "0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.introSlide < 2 ? 'Next' : 'Get Started'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "style"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_158, [
          _createElementVNode("div", _hoisted_159, [
            _createVNode(_component_v_chip, {
              "prepend-icon": _ctx.cloudIcon,
              variant: "outlined",
              size: "small",
              elevation: "3",
              text: _ctx.selectedLocationText,
              onClick: _cache[71] || (_cache[71] = () => {
            _ctx.searchOpen = true; 
            _ctx.learnerPath = 'Location'
            })
            }, null, 8, ["prepend-icon", "text"]),
            _createVNode(_component_v_chip, {
              "prepend-icon": _ctx.smallSize ? `` : `mdi-clock`,
              variant: "outlined",
              size: "small",
              elevation: "1",
              text: _ctx.selectedLocaledTimeDateString
            }, null, 8, ["prepend-icon", "text"]),
            (_ctx.showNewMobileUI)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  "prepend-icon": _ctx.smallSize ? `` : `mdi-sun-angle`,
                  variant: "outlined",
                  elevation: "1",
                  size: "small",
                  text: _ctx.percentEclipsedText
                }, null, 8, ["prepend-icon", "text"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.showNewMobileUI)
            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _createVNode(_component_hover_tooltip, {
                    location: "left",
                    disabled: _ctx.mobile
                  }, {
                    target: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        inset: "",
                        "hide-details": "",
                        modelValue: _ctx.toggleTrackSun,
                        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.toggleTrackSun) = $event)),
                        ripple: false,
                        color: _ctx.accentColor,
                        "true-icon": "mdi-white-balance-sunny",
                        "false-icon": "mdi-image",
                        onKeyup: _cache[73] || (_cache[73] = _withKeys(($event: any) => (_ctx.toggleTrackSun = !_ctx.toggleTrackSun), ["enter"])),
                        tabindex: "0"
                      }, null, 8, ["modelValue", "color"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.toggleTrackSun ? "Stop Tracking Sun" : 'Start Tracking Sun'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_162, [
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.showForecastSheet,
            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.showForecastSheet) = $event)),
            "max-width": _ctx.xSmallSize ? '85%' : '45%',
            transition: "slide-y-transition",
            id: "weather-forecast-sheet"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-8" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        style: {"position":"absolute","right":"12px","cursor":"pointer","padding":"1em","margin":"-1em"},
                        icon: "square-xmark",
                        size: "xl",
                        onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.showForecastSheet = false)),
                        onKeyup: _cache[75] || (_cache[75] = _withKeys(($event: any) => (_ctx.showForecastSheet = false), ["enter"])),
                        tabindex: "0"
                      }),
                      _createVNode(_component_open_meteo_forecast, {
                        location: _ctx.locationDeg,
                        "location-str": _ctx.selectedLocationText,
                        timezone: _ctx.selectedTimezone,
                        time: (_ctx.eclipsePrediction !== null && _ctx.eclipseType != 'None') ? _ctx.eclipsePrediction.maxTime[0] : null
                      }, null, 8, ["location", "location-str", "timezone", "time"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width"]),
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.showEclipsePredictionSheet,
            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.showEclipsePredictionSheet) = $event)),
            "max-width": "fit-content",
            transition: "slide-y-transition",
            id: "eclipse-prediction-sheet"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        style: {"position":"absolute","right":"12px","cursor":"pointer","padding":"1em","margin":"-1em"},
                        icon: "square-xmark",
                        size: "xl",
                        onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.showEclipsePredictionSheet = false)),
                        onKeyup: _cache[78] || (_cache[78] = _withKeys(($event: any) => (_ctx.showEclipsePredictionSheet = false), ["enter"])),
                        tabindex: "0"
                      }),
                      _createVNode(_component_eclipse_timer, {
                        "show-timer": "",
                        prediction: _ctx.eclipsePrediction,
                        timezone: _ctx.selectedTimezone,
                        color: _ctx.accentColor,
                        location: _ctx.selectedLocationText
                      }, null, 8, ["prediction", "timezone", "color", "location"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showNewMobileUI)
            ? (_openBlock(), _createBlock(_component_icon_button, {
                key: 0,
                modelValue: _ctx.showInfoSheet,
                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
                "fa-icon": "book-open",
                "fa-size": "lg",
                color: _ctx.accentColor,
                "focus-color": _ctx.accentColor,
                "tooltip-text": _ctx.showInfoSheet ? null : 'More on Eclipses',
                "tooltip-location": 'left',
                "show-tooltip": !_ctx.mobile,
                "box-shadow": false
              }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"]))
            : _createCommentVNode("", true),
          _createVNode(_component_icon_button, {
            id: "eclipse-details-button",
            "md-icon": "sun-clock",
            "md-size": _ctx.showNewMobileUI ? '16' : '24',
            color: _ctx.accentColor,
            "focus-color": _ctx.accentColor,
            "tooltip-text": "View eclipse timing details",
            "tooltip-location": "start",
            onActivate: _cache[81] || (_cache[81] = () => {
          _ctx.showEclipsePredictionSheet = true;
          if (!_ctx.showEclipsePredictionText) {
            _ctx.showEclipsePredictionTextBanner = !_ctx.showNewMobileUI;
          }
          _ctx.showEclipsePredictionText = true;
        })
          }, null, 8, ["md-size", "color", "focus-color"]),
          _createVNode(_component_icon_button, {
            modelValue: _ctx.showForecastSheet,
            "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.showForecastSheet) = $event)),
            "md-icon": "mdi-cloud-clock",
            "md-size": _ctx.showNewMobileUI ? '16' : '24',
            color: _ctx.accentColor,
            "focus-color": _ctx.accentColor,
            "tooltip-text": _ctx.showForecastSheet ? null : 'April 8 Weather Forecast',
            "tooltip-location": 'left',
            "show-tooltip": !_ctx.mobile,
            "box-shadow": false
          }, null, 8, ["modelValue", "md-size", "color", "focus-color", "tooltip-text", "show-tooltip"]),
          (!_ctx.showNewMobileUI)
            ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                _createElementVNode("div", _hoisted_164, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "lg",
                    color: _ctx.accentColor,
                    icon: _ctx.showControls ? `chevron-down` : `gear`,
                    onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.showControls = !_ctx.showControls)),
                    onKeyup: _cache[84] || (_cache[84] = _withKeys(($event: any) => (_ctx.showControls = !_ctx.showControls), ["enter"])),
                    tabindex: "0"
                  }, null, 8, ["color", "icon"])
                ]),
                (_ctx.showControls)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                      (!_ctx.showNewMobileUI)
                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                            key: 0,
                            color: _ctx.accentColor,
                            modelValue: _ctx.sunCenteredTracking,
                            "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.sunCenteredTracking) = $event)),
                            onChange: _cache[86] || (_cache[86] = ($event: any) => (_ctx.centerSun())),
                            label: "Center Sun",
                            disabled: _ctx.sunCenteredTracking,
                            "hide-details": ""
                          }, null, 8, ["color", "modelValue", "disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showAltAzGrid,
                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.showAltAzGrid) = $event)),
                        onKeyup: _cache[88] || (_cache[88] = _withKeys(($event: any) => (_ctx.showAltAzGrid = !_ctx.showAltAzGrid), ["enter"])),
                        label: "Sky Grid",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showHorizon,
                        "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.showHorizon) = $event)),
                        onKeyup: _cache[90] || (_cache[90] = _withKeys(($event: any) => (_ctx.showHorizon = !_ctx.showHorizon), ["enter"])),
                        label: "Horizon/Daytime Sky",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.useRegularMoon,
                        "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.useRegularMoon) = $event)),
                        onKeyup: _cache[92] || (_cache[92] = _withKeys(($event: any) => (_ctx.useRegularMoon = !_ctx.useRegularMoon), ["enter"])),
                        label: "Visible Moon",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _withDirectives(_createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showEclipsePredictionTextBanner,
                        "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.showEclipsePredictionTextBanner) = $event)),
                        onKeyup: _cache[94] || (_cache[94] = _withKeys(($event: any) => (_ctx.showEclipsePredictionTextBanner = !_ctx.showEclipsePredictionTextBanner), ["enter"])),
                        label: "Eclipse Timing",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]), [
                        [_vShow, !_ctx.showNewMobileUI]
                      ]),
                      _withDirectives(_createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showOldMobileUI,
                        "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.showOldMobileUI) = $event)),
                        onKeyup: _cache[96] || (_cache[96] = _withKeys(($event: any) => (_ctx.showOldMobileUI = !_ctx.showOldMobileUI), ["enter"])),
                        label: "Detailed Interface",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]), [
                        [_vShow, _ctx.narrow]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_166, [
            _createVNode(_component_v_btn, {
              id: "set-time-now-button",
              variant: "outlined",
              rounded: "xl",
              disabled: _ctx.nowOutsideTimeRange,
              color: _ctx.nowOutsideTimeRange ? 'gray' : '#eac402',
              onClick: _cache[97] || (_cache[97] = () => {
            _ctx.selectedTime = Math.max(_ctx.minTime, Math.min(_ctx.maxTime, Date.now()));
            _ctx.playbackRate=1;
            _ctx.playing=true;
            })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Now ")
              ]),
              _: 1
            }, 8, ["disabled", "color"]),
            (!_ctx.showNewMobileUI)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  "prepend-icon": _ctx.smallSize ? `` : `mdi-sun-angle`,
                  variant: "outlined",
                  elevation: "1",
                  text: _ctx.percentEclipsedText
                }, null, 8, ["prepend-icon", "text"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_167, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showVideoSheet,
              "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
              id: "video-icon",
              "fa-icon": "video",
              "fa-size": "lg",
              color: _ctx.accentColor,
              "tooltip-text": "Video guide",
              "tooltip-location": "start",
              "tooltip-offset": _ctx.smallSize ? 0 : '10px'
            }, null, 8, ["modelValue", "color", "tooltip-offset"])
          ]),
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("span", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("div", _hoisted_171, [
                  _createVNode(_component_icon_button, {
                    id: "reverse-speed",
                    "fa-icon": 'angles-left',
                    onActivate: _cache[99] || (_cache[99] = () => {
                      _ctx.reversePlaybackRate();
                      // playing = true;
                    }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": _ctx.playbackRate < 0 ? 'Reverse Faster' : 'Reverse',
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "1x",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "tooltip-text", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    id: "play-pause-icon",
                    "fa-icon": !(_ctx.playing) ? 'play' : 'pause',
                    onActivate: _cache[100] || (_cache[100] = () => {
                  _ctx.playing = !(_ctx.playing);
                }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": "Play/Pause",
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "1x",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["fa-icon", "color", "focus-color", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    id: "forward-speed",
                    "fa-icon": 'angles-right',
                    onActivate: _cache[101] || (_cache[101] = () => {
                      _ctx.increasePlaybackRate();
                      // playing = true;
                    }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": _ctx.playbackRate > 0 ? 'Faster' : 'Forward',
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "1x",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "tooltip-text", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    id: "reset",
                    "fa-icon": 'rotate',
                    onActivate: _cache[102] || (_cache[102] = () => {
                  _ctx.selectedTime = (new Date('2024-04-08T18:18:00Z')).getTime() - 60*60*1000*1.5;
                  _ctx.playbackRate = 500;
                  _ctx.playing = false;
                  _ctx.toggleTrackSun = true;
                  _ctx.forceRate = false;
                }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": "Reset",
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "1x",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "show-tooltip"]),
                  (!_ctx.xSmallSize)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 0,
                        modelValue: _ctx.playbackVisible,
                        "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.playbackVisible) = $event)),
                        scrim: false,
                        location: "top",
                        offset: "40",
                        "location-strategy": "connected",
                        persistent: "",
                        "no-click-animation": "",
                        "retain-focus": false
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_icon_button, _mergeProps({
                            id: "speed-control-icon",
                            onActivate: _cache[103] || (_cache[103] = () => {
                      _ctx.playbackVisible = !_ctx.playbackVisible;
                    }),
                            "fa-icon": _ctx.playbackVisible ? 'times' : 'gauge-high',
                            color: _ctx.accentColor,
                            "focus-color": _ctx.accentColor,
                            "tooltip-text": "Speed Controls",
                            "tooltip-location": "top",
                            "tooltip-offset": "5px",
                            faSize: "1x",
                            "show-tooltip": !_ctx.mobile
                          }, props), null, 16, ["fa-icon", "color", "focus-color", "show-tooltip"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.playbackVisible)
                            ? (_openBlock(), _createBlock(_component_playback_control, {
                                key: 0,
                                class: "desktop-playback-control",
                                "model-value": _ctx.playbackRate,
                                "onUpdate:modelValue": _cache[104] || (_cache[104] = (value) => {
                        _ctx.forceRate = false;
                        _ctx.playbackRate = value;
                      }),
                                paused: !_ctx.playing,
                                onPaused: _cache[105] || (_cache[105] = ($event: any) => (_ctx.playing = !$event)),
                                "max-power": 3,
                                max: Math.log10(1000) + 1,
                                color: _ctx.accentColor,
                                inline: false,
                                "show-close-button": "",
                                onClose: _cache[106] || (_cache[106] = () => {
                        _ctx.playbackVisible = false;
                      })
                              }, null, 8, ["model-value", "paused", "max", "color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.xSmallSize)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                        _createVNode(_component_icon_button, {
                          id: "speed-control-icon",
                          onActivate: _cache[108] || (_cache[108] = () => {
                      _ctx.playbackVisible = !_ctx.playbackVisible;
                    }),
                          "fa-icon": _ctx.playbackVisible ? 'times' : 'gauge-high',
                          color: _ctx.accentColor,
                          "focus-color": _ctx.accentColor,
                          "tooltip-text": "Time Controls",
                          "tooltip-location": "top",
                          "tooltip-offset": "5px",
                          faSize: "1x",
                          "show-tooltip": !_ctx.mobile
                        }, null, 8, ["fa-icon", "color", "focus-color", "show-tooltip"]),
                        _withDirectives(_createVNode(_component_playback_control, {
                          class: "mobile-playback-control",
                          "model-value": _ctx.playbackRate,
                          "onUpdate:modelValue": _cache[109] || (_cache[109] = (value) => {
                        _ctx.forceRate = false;
                        _ctx.playbackRate = value;
                      }),
                          paused: !_ctx.playing,
                          onPaused: _cache[110] || (_cache[110] = ($event: any) => (_ctx.playing = !$event)),
                          "max-power": 3,
                          max: Math.log10(1000) + 1,
                          color: _ctx.accentColor,
                          inline: true,
                          "inline-button": "",
                          onClose: _cache[111] || (_cache[111] = () => {
                        _ctx.playbackVisible = false;
                      })
                        }, null, 8, ["model-value", "paused", "max", "color"]), [
                          [_vShow, _ctx.playbackVisible]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_173, [
                  _createTextVNode(" Time rate: "),
                  (_ctx.playbackRate===1 && _ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_174, " Real time "))
                    : _createCommentVNode("", true),
                  (_ctx.playbackRate!=1 && _ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_175, _toDisplayString(_ctx.niceRound(_ctx.playbackRate)) + "× ", 1))
                    : _createCommentVNode("", true),
                  (!_ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_176, " (" + _toDisplayString(_ctx.niceRound(_ctx.playbackRate)) + "×) Paused ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.playing && _ctx.forceRate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_177, " (Slowed for totality) "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_178, [
                _createVNode(_component_v_slider, {
                  modelValue: _ctx.selectedTime,
                  "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.selectedTime) = $event)),
                  max: _ctx.maxTime,
                  min: _ctx.minTime,
                  color: _ctx.accentColor,
                  ripple: false,
                  "hide-details": "",
                  "track-size": "8px",
                  "thumb-size": "20px",
                  "thumb-label": "always",
                  step: _ctx.millisecondsPerInterval,
                  onMousedown: _cache[113] || (_cache[113] = () => {_ctx.playing = false;})
                }, {
                  "thumb-label": _withCtx((item) => [
                    _createTextVNode(_toDisplayString(_ctx.toTimeString(new Date(item.modelValue))), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "max", "min", "color", "step"])
              ]),
              _createElementVNode("div", _hoisted_179, [
                _createVNode(_component_icon_button, {
                  "md-icon": "mdi-lock",
                  onActivate: _cache[114] || (_cache[114] = () => _ctx.showPrivacyDialog = true),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "Change privacy settings",
                  "tooltip-location": "bottom",
                  "tooltip-offset": "5px",
                  "show-tooltip": !_ctx.mobile,
                  mdSize: "1em"
                }, null, 8, ["color", "focus-color", "show-tooltip"])
              ])
            ])
          ]),
          (!_ctx.smallSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_dialog, {
          scrim: "false",
          modelValue: _ctx.showPrivacyDialog,
          "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.showPrivacyDialog) = $event)),
          "max-width": "400px",
          id: "privacy-popup-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" To evaluate usage of this app, "),
                    _hoisted_181,
                    _createTextVNode(" data may be collected, including locations viewed and map quiz responses. \"My Location\" data is NEVER collected. ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "pt-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "#BDBDBD",
                      href: "https://www.cfa.harvard.edu/privacy-statement",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Privacy Policy ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "#ff6666",
                      onClick: _cache[115] || (_cache[115] = () => {
              _ctx.responseOptOut = true;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Opt out ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "green",
                      onClick: _cache[116] || (_cache[116] = () => {
              _ctx.responseOptOut = false;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Allow ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_notifications, {
          group: "copy-url",
          position: "center top",
          classes: "url-notification"
        }),
        _createVNode(_component_notifications, {
          dangerouslySetInnerHtml: "",
          group: "geolocation-error",
          position: "center top"
        })
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (_ctx.showRating)
            ? (_openBlock(), _createBlock(_component_user_experience, {
                key: 0,
                question: _ctx.question,
                "icon-size": "3x",
                onDismiss: _cache[121] || (_cache[121] = (_rating, _comments) => {
        _ctx.showRating = false;
      }),
                onRating: _cache[122] || (_cache[122] = (rating) => {
        _ctx.currentRating = rating;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
      }),
                onFinish: _cache[123] || (_cache[123] = (rating, comments) => {
        _ctx.currentRating = rating;
        _ctx.currentComments = comments;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
        _ctx.showRating = false;
      })
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_182, [
                    _createVNode(_component_v_btn, {
                      class: "rating-opt-put",
                      color: "#BDBDBD",
                      size: "small",
                      variant: "text",
                      onClick: _cache[118] || (_cache[118] = () => {
              _ctx.showRating = false;
              _ctx.ratingOptOut = true;
            })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Don't show again ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "privacy-button",
                      color: "#BDBDBD",
                      onClick: _cache[119] || (_cache[119] = ($event: any) => (_ctx.showRatingPrivacyPolicy = true)),
                      onKeyup: _cache[120] || (_cache[120] = _withKeys(($event: any) => (_ctx.showRatingPrivacyPolicy = true), ["enter"])),
                      size: "small",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" What is this? ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["question"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_cds_privacy_policy, {
        modelValue: _ctx.showRatingPrivacyPolicy,
        "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.showRatingPrivacyPolicy) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}